import {
    Button,
    FormControl,
    FormLabel, Input, InputGroup, InputRightAddon, Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent, ModalFooter,
    ModalHeader,
    ModalOverlay, Select
} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
const DesignModal = ({isOpen, onClose, handleAddTech, isEdit, currentRecordIdx, items}) => {
    const [selectedTech, setSelectedTech] = useState("PV");
    const [currentFields, setCurrentFields] = useState([]);

    const getFields = (tech) => {
        const fields = items.find(ele => ele.label === tech)?.inputs;
        return fields.map(field => {
            if (field.hasOwnProperty("value")) {
                return field;
            }
            if (field.hasOwnProperty("defaultValue")) {
                return {...field, value: field.defaultValue};
            }
            if (field.inputType === "number")
                return {...field, value: "0.0"};
            else
                return {...field, value: ""};
        });
    }

    useEffect(() => {
        setSelectedTech(items[currentRecordIdx].label);
    }, [currentRecordIdx]);

    useEffect(()=> {
        setCurrentFields(getFields(selectedTech));
    }, [selectedTech]);

    useEffect(() => {
        if (!isEdit) {
            for (let item of items) {
                if (!item.isAdded) {
                    setCurrentFields(getFields(item.label));
                    setSelectedTech(item.label);
                    break;
                }
            }
        } else {
            setCurrentFields(getFields(items[currentRecordIdx].label));
            setSelectedTech(items[currentRecordIdx].label);
        }
    }, [isOpen]);


    const onTechChange = (e) => {
        const tech = e.target.value;
        setSelectedTech(tech);
    }

    const handleFieldChange = (field, value) => {
        const updatedFields = currentFields.map(currentField => currentField === field ? {...currentField, value: value} : currentField);
        setCurrentFields(updatedFields);
    };


    return (
        <Modal isOpen={isOpen} onClose={onClose} size={"2xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Add New Technology</ModalHeader>
                <ModalCloseButton />
                <ModalBody >
                    <FormControl>
                        <FormLabel>Select Technology</FormLabel>
                        <Select value={selectedTech} onChange={onTechChange}  isDisabled={isEdit}>
                            {
                                items.map(item => (
                                    <option value={item.label} disabled={item.isAdded}>{item.label}</option>
                                ))
                            }
                        </Select>
                    </FormControl>
                    {currentFields.map((field, index) => (
                        <FormControl mt={4} key={index}>
                            <FormLabel>{field.label} {field.inputType === "number" && `(${field.units})`}</FormLabel>
                            <InputGroup>
                                <Input type={field.inputType} value={field.value} onChange={(e) => handleFieldChange(field, e.target.value)} />

                                {field.inputType === "number" &&   <InputRightAddon children={field.units} />}
                            </InputGroup>
                        </FormControl>
                    ))}
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="teal" mr={3} onClick={() => handleAddTech(selectedTech, currentFields)}>Submit</Button>
                    <Button onClick={onClose}>Cancel</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default DesignModal;